module.exports = __webpack_public_path__ + "static/media/profile.93bbcdbb.PNG";